import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { ArchivoCargueAdminInfI } from 'src/app/modelos/ArchivoCargueAdminInf';
import { DeptoI } from 'src/app/modelos/departamento.interface';
import { DivipolaI } from 'src/app/modelos/Divipola';
import { EstadoInfoFiviI } from 'src/app/modelos/EstadoInformacionFivi';
import { fuenteI } from 'src/app/modelos/fuentes.interface';
import { OperacionI } from 'src/app/modelos/operacionEsta.interface';
import { PeriodoReporteFiviI } from 'src/app/modelos/PeriodoReporteFivi';
import { ResCargueExcelAdminInfFiviI } from 'src/app/modelos/ResCargueExcelAdminInfFivi';
import { ResponseCargueI } from 'src/app/modelos/ResponseCargue';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-cargueminformfivi',
  templateUrl: './cargueminformfivi.component.html',
  styleUrls: ['./cargueminformfivi.component.css']
})
export class CargueminformfiviComponent implements OnDestroy,OnInit {

  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  Operacion : OperacionI = new OperacionI;
  fuentesFivi : fuenteI[];
  Depto : DeptoI = new DeptoI;
  Muni : DivipolaI = new DivipolaI;
  FuenteCargueM : fuenteI = new fuenteI;
  PeriodosConsultar : PeriodoReporteFiviI[];
  PeriodoCargueMasivo : PeriodoReporteFiviI = new PeriodoReporteFiviI;
  EstadoInfomacionFuenteCargue : EstadoInfoFiviI = new EstadoInfoFiviI;
  ObservacionCargue : String;
  file: any;
  contenidoDocumento: string;
  ArchivoCargueMasivo : ArchivoCargueAdminInfI = new ArchivoCargueAdminInfI;
  FechaHoy : Date = new Date();
  RespuestaCargue : ResponseCargueI = new ResponseCargueI;

  BtnCargarArchivo : Boolean = false;
  CargueExitoso : Boolean = false;
  ErrorCargue : Boolean = false;
  BtnConfirmarCargue : Boolean = false;

  @ViewChild('OpenModalCargueMasivo') OpenModalCargueMasivo: ElementRef;
  @ViewChild('CloseModalCargueMasivo') CloseModalCargueMasivo: ElementRef;

  pdfUrl: string = 'assets/Formatos/Guia diligenciamiento_FIVI.pdf';
  xlsxUrl: string = 'assets/Formatos/Plantilla FIVI Fuentes.xlsx';

  constructor(
    private api:ApiService,
    private router:Router,
    private toastr: ToastrService,
    private appService:AppServiceService
  ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      responsive: true,
      language:
        {
          "processing": "Procesando...",
          "lengthMenu": "Mostrar _MENU_ registros",
          "zeroRecords": "No se encontraron resultados",
          "emptyTable": "Ningún dato disponible en esta tabla",
          "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "infoFiltered": "(filtrado de un total de _MAX_ registros)",
          "search": "Buscar:",
          "loadingRecords": "Cargando...",
          "paginate": {
              "first": "Primero",
              "last": "Último",
              "next": "Siguiente",
              "previous": "Anterior"
          },
          "aria": {
              "sortAscending": ": Activar para ordenar la columna de manera ascendente",
              "sortDescending": ": Activar para ordenar la columna de manera descendente"
          },
          "info": "Mostrando de _START_ a _END_ de _TOTAL_ estados"
        }
    };
    this.Operacion.id =2;
    this.Operacion.descripcion= "Financiacion de Vivienda";
    this.Operacion.nombre = "FIVI";
    this.api.getFuentesByOpe(this.Operacion).subscribe(data=>{
      this.dtTrigger.next();
      this.fuentesFivi = data;
      for (let fte of this.fuentesFivi){
        this.api.getdeptoByCod(fte.depto).subscribe(depto0=>{
          this.Depto = depto0;
          fte.depto = depto0.nombre;
        });
        this.api.getMuniByCodigo(fte.muni).subscribe(muni0=>{
          this.Muni = muni0;
          fte.muni = muni0.nommpio;
        });
      }
    });
    this.ObservacionCargue = "";
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  RegresarAdminFivi(){
    this.router.navigate(['admininfofivi']);
  }

  RealizarCargueMasivo(idFte){
    this.OpenModalCargueMasivo.nativeElement.click();
    this.ObservacionCargue = "";
    this.BtnCargarArchivo = true;
    this.CargueExitoso = false;
    this.ErrorCargue = false;
    this.BtnConfirmarCargue = false;
    this.api.getFuenteById(idFte).subscribe(result1=>{
      this.FuenteCargueM = result1;
      this.api.listaPeriodosCalendarioFivi().subscribe(result2=>{
        this.PeriodosConsultar = result2;
      });
    });
  }

  CerrarModalCargueFuente(){
    if(this.CargueExitoso){
      this.toastr.warning('Debe confirmar el cargue.', 'Advertencia!');
    } else {
      this.CloseModalCargueMasivo.nativeElement.click();
    }
  }

  public uploadFile(event){
    this.BtnCargarArchivo = false;
    this.CargueExitoso = false;
    this.ErrorCargue = false;
    this.BtnConfirmarCargue = false;
    this.file = (event.target as HTMLInputElement).files[0];
    if(this.file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      this.file.type=='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      this.file.type=='application/vnd.ms-excel'){
      //console.log("Nombre del archivo: " + this.file.name + " , Tipo: " + this.file.type);
    }else{
      this.toastr.error('Solamente se permiten archivos tipo EXCEL.', 'Error!');
      return;
    }
    let comp = this;
    let reader = new FileReader();
        reader.readAsDataURL(this.file);
        reader.onload = function () {
          comp.contenidoDocumento = reader.result.toString();
        };
        reader.onerror = function (error) {
          console.log('Error: ', error);
          return error;
        };
  }

  ConsultarExisteReporte(idPeri){
    this.api.ConsultaReportoPeriodoFivi(this.FuenteCargueM.id, idPeri).subscribe(result3=>{
      if(result3){
        this.BtnCargarArchivo = false;
        this.ErrorCargue = false;
        this.api.PeriodoFiviPorId(idPeri).subscribe(result4=>{
          this.PeriodoCargueMasivo = result4;
          this.api.EstadoInfParaFuenteFivi(result4.id, this.FuenteCargueM.id).subscribe(result5=>{
            this.EstadoInfomacionFuenteCargue = result5;
          });
        });
      } else {
        this.BtnCargarArchivo = true;
        this.toastr.warning('Existe información registrada para el periodo seleccionado.', 'Advertencia!');
      }
    });
  }

  VerificarDocumentoCargue(){
    this.BtnCargarArchivo = true;


    if(this.PeriodoCargueMasivo.id == undefined || this.PeriodoCargueMasivo.id == null){
      this.toastr.warning('Seleccione un periodo.', 'Advertencia!');
      this.BtnCargarArchivo = false;
    }else if(this.contenidoDocumento == undefined || this.contenidoDocumento == null || this.contenidoDocumento == ""){
      this.toastr.warning('Debe cargar un archivo.', 'Advertencia!');
      this.BtnCargarArchivo = false;
    }else{
      this.ArchivoCargueMasivo.nombre = this.file.name;
      this.ArchivoCargueMasivo.comentario = "";
      this.ArchivoCargueMasivo.tipo = this.file.type;
      this.ArchivoCargueMasivo.fechaCarga = this.FechaHoy.getDate() +"/"+ (this.FechaHoy.getMonth()+1) +"/"+ this.FechaHoy.getFullYear();
      this.ArchivoCargueMasivo.rutaArch = "";
      this.ArchivoCargueMasivo.contenido = this.contenidoDocumento;
      this.ArchivoCargueMasivo.idUsuarioCarga = +localStorage.getItem('id');
      this.ArchivoCargueMasivo.idFuente = this.FuenteCargueM.id;
      this.ArchivoCargueMasivo.idPeriodo = this.PeriodoCargueMasivo.id;
      this.api.VerificarContenidoDocumentoFivi(this.ArchivoCargueMasivo).subscribe(result6=>{
        this.RespuestaCargue = result6;
        if(result6.estado == "ERROR"){
          this.BtnCargarArchivo = true;
          this.CargueExitoso = false;
          this.ErrorCargue = true;
          this.BtnConfirmarCargue = false;
        }
        if(result6.estado == "OK"){
          this.BtnCargarArchivo = true;
          this.CargueExitoso = true;
          this.ErrorCargue = false;
          this.BtnConfirmarCargue = false;
        }
        if(result6.estado == "ERROR ARCHIVO"){
          this.toastr.info('Problema con el formato cargado.', 'ERROR!');
          this.BtnCargarArchivo = true;
          this.CargueExitoso = false;
          this.ErrorCargue = false;
          this.BtnConfirmarCargue = false;
        }
      });
    }
  }

  DescargarErrores(){
    var workbook = XLSX.utils.book_new();
    var ws1 = XLSX.utils.table_to_sheet(document.getElementById("ErroresCargue"));
    XLSX.utils.book_append_sheet(workbook, ws1, "ErroresCargue");
    XLSX.writeFile(workbook, "Errores_Cargue_"+this.FuenteCargueM.codEnti+".xlsx");
  }

  ConfirmarCargue(){
    this.BtnConfirmarCargue = true;
    this.ArchivoCargueMasivo.comentario = this.ObservacionCargue;
    if(this.ObservacionCargue == "" || this.ObservacionCargue == null || this.ObservacionCargue.length == 0){
      this.toastr.warning('Ingresar observación.', 'Advertencia!');
      this.BtnConfirmarCargue = false;
    }else if(this.ObservacionCargue.length < 20 ){
      this.toastr.warning('Observación debe tener mínimo 20 caracteres.', 'Advertencia!');
      this.BtnConfirmarCargue = false;
    }else if(this.ObservacionCargue.length > 500 ){
      this.toastr.warning('Observación debe tener máximo 500 caracteres.', 'Advertencia!');
      this.BtnConfirmarCargue = false;
    } else {
      this.api.ConfirmacionCargueMasivoAdminInfoFivi(this.ArchivoCargueMasivo).subscribe(result7=>{
        if(result7.estado == "ERROR"){
          this.BtnCargarArchivo = true;
          this.CargueExitoso = false;
          this.ErrorCargue = true;
          this.BtnConfirmarCargue = false;
          this.ObservacionCargue = "";
          this.toastr.error('No se guardó.', 'Error!');
          this.CloseModalCargueMasivo.nativeElement.click();
        }
        if(result7.estado == "OK"){
          this.BtnCargarArchivo = true;
          this.CargueExitoso = true;
          this.ErrorCargue = false;
          this.BtnConfirmarCargue = false;
          this.ObservacionCargue = "";
          this.toastr.success('Cargue confirmado.', 'OK!');
          this.CloseModalCargueMasivo.nativeElement.click();
        }
      });
    }
  }




  exportarExcel(idTabla:string){
    var workbook = XLSX.utils.book_new();
    var ws1 = XLSX.utils.table_to_sheet(document.getElementById(idTabla));
    XLSX.utils.book_append_sheet(workbook, ws1, idTabla);
    XLSX.writeFile(workbook, idTabla+".xlsx");
  }






}
